<template>
  <popup ref="popup" :loading="popupLoading" @beforeClose="close">
    <div slot="body" style="padding-top: 20px">

      <div class="operator">
        <el-row>
          <el-col :span="5">
            <span class="text">
              <el-tooltip class="item" :content="studentNeedList" effect="dark" placement="bottom">
                <span> 已批 / 交卷 / 应考 ： {{ row.judgedsum ? row.judgedsum : 0 }} / {{ row.studysum }} / {{
    row.sid ? row.sid.split(",").length : 0 }}</span>
              </el-tooltip>
            </span>
          </el-col>
          <el-col :span="7">
            <el-button :type="stuIndex < 1 ? '' : 'primary'" size="mini" :disabled="stuIndex < 1"
              @click="moveStu(-1)">《《</el-button>
            <el-button @click="showYK" :title="studentListTxt" type="success" size="mini">{{ stuIndex + 1 }}.{{
    student.name }}</el-button>
            <el-button :type="stuIndex > (studentList.length - 2) ? '' : 'primary'" size="mini"
              :disabled="stuIndex > (studentList.length - 2)" @click="moveStu(1)">》》</el-button>
            <el-button type="warning" size="mini" v-show="!stuAnwser.isjudged" @click="submitPigai()">
              {{ parameter.type == 3 ? '公布答案' : '完成批改' }} </el-button>
            <el-button type="danger" size="mini" @click="reExam()"> 重考 </el-button>
            <el-button type="warning" size="mini" v-if="stuAnwser.isjudged" @click="reJudge()"> 重改 </el-button>
          </el-col>
          <el-col :span="3">
            得分 ：{{ allScore }} / {{ maxScore }}
          </el-col>
          <el-col :span="9">
            未考： <el-tag type="danger" size="mini" v-for="(v, i) in studentNoKao" :key="'v' + i">{{ v }}</el-tag>
          </el-col>
        </el-row>
      </div>
      <el-form class="dataForm" ref="form" :disabled="disabled" :inline="true">
        <el-row>
          <el-col :span="24">
            <!-- 单选 -->
            <div v-if="questionArray.t1[0]">
              <el-collapse>
                <el-collapse-item :title="(questionArray.t1[0].i + 1) + '.单选'" name="xx">
                  <el-card v-for="(qu, idx1) in questionArray.t1" :key="idx1 + '1'">
                    <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b> <b>{{ qu.question.title }}</b>
                    <span>[{{ qu.qscore }}分]
                      <b>(</b> <span style="color:#00F">{{ qu.flag }}</span> <b>)</b>&nbsp;&nbsp; 本题<el-tag size="mini"
                        :type="qu.rslt ? 'success' : 'danger'">{{ qu.rslt ? "正确" : "错误" }}</el-tag><span
                        v-if="parameter.type != 3"> ，得{{
    qu.rscore
  }}分。</span></span>
                    <div v-for="(ch, idx2) in qu.question.choiceList" :key="idx2 + '11'">
                      <el-button :class="ch.n" plain>{{ ch.o }}.{{ ch.n }}</el-button>
                    </div>
                    <div style="width: 50%">
                      <span style="color: #0c0;">标准答案：<br><i style="color: #00f" v-html="qu.rigthAnsr"> </i></span> <br>
                      <span style="color: red;">题目解析:</span><br>
                      <!-- 题目解析按钮 -->
                      <el-button type="primary" :type="qu.stuanswer ? 'warning' : 'primary'" size="mini"
                        @click="getCurrentAnalysis(qu)">更新答案-解析 {{
    qu.stuanswer ? '(' + qu.stuanswer.sn + '-' + qu.stuanswer.uptm + '有提交更新)' : '' }} </el-button>
                    </div>
                  </el-card>
                </el-collapse-item>
              </el-collapse>
            </div>

            <!-- 多选 -->
            <div v-if="questionArray.t2[0]">
              <el-collapse v-show="questionArray.t2">
                <el-collapse-item :title="(questionArray.t2[0].i + 1) + '.多选'" name="2">
                  <el-card v-for="(qu, idx1) in questionArray.t2" :key="idx1 + '2'">
                    <span><b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b> <b>{{ qu.question.title }}</b>
                      <b style="color:#00CC00">[{{ qu.qscore }}分]</b>
                      <b> (</b> <b style="color:#00F" v-for="(j, idx2) in qu.flag" :key="idx2 + '22'">{{ j }}</b><b>)
                      </b>
                      本题<el-tag size="mini" :type="handlerScoringSituation(qu.rslt).status">{{
    handlerScoringSituation(qu.rslt).ctx
  }}</el-tag><span v-if="parameter.type != 3"> 得{{ qu.rscore }}分。</span></span>

                    <div v-for="(ch, idx3) in qu.question.choiceList" :key="idx3 + '222'">
                      <el-button plain :class="qu.n + idx1">{{ ch.o }}.{{ ch.n }}</el-button>
                    </div>
                    <div style="width: 50%">
                      <span style="color: #0c0">标准答案：<br><i style="color: #00f" v-html="qu.rigthAnsr"> </i></span> <br>
                      <span style="color: red;">题目解析:</span><br>

                      <!-- 题目解析按钮 -->
                      <el-button type="primary" :type="qu.stuanswer ? 'warning' : 'primary'" size="mini"
                        @click="getCurrentAnalysis(qu)">更新答案-解析 {{
    qu.stuanswer ? '(' + qu.stuanswer.sn + '-' + qu.stuanswer.uptm + '有提交更新)' : '' }} </el-button>
                    </div>
                  </el-card>
                </el-collapse-item>
              </el-collapse>
            </div>

            <!-- 判断 -->
            <div v-if="questionArray.t3[0]">
              <el-collapse>
                <el-collapse-item :title="(questionArray.t3[0].i + 1) + '.判断'" name="3">
                  <el-card v-for="(qu, idx1) in questionArray.t3" :key="idx1 + '3'">
                    <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b> <b>{{ qu.question.title }}</b> [{{ qu.qscore }}分]

                    <b>(</b> {{ qu.flag == 0 ? "X " : "V " }} <b> ) </b>
                    <span> &nbsp;&nbsp; 本题<el-tag size="mini" :type="qu.rslt ? 'success' : 'danger'">{{
    qu.rslt ? "正确" : "错误"
  }}</el-tag><span v-if="parameter.type != 3"> ，得{{ qu.rscore }}分。</span></span>
                    <br />

                    <input :disabled="true" v-model="qu.flag" value="1" type="radio" :name="qu.id" />正确
                    <input :disabled="true" v-model="qu.flag" value="0" type="radio" :name="qu.id" />错误
                    <div style="width: 50%">
                      <span style="color: #0c0">标准答案：<br><i style="color: #00f" v-html="qu.rigthAnsr"></i></span> <br>
                      <span style="color: red;">题目解析:</span><br>

                      <!-- 题目解析按钮 -->
                      <el-button type="primary" :type="qu.stuanswer ? 'warning' : 'primary'" size="mini"
                        @click="getCurrentAnalysis(qu)">更新答案-解析 {{
    qu.stuanswer ? '(' + qu.stuanswer.sn + '-' + qu.stuanswer.uptm + '有提交更新)' : '' }} </el-button>
                    </div>
                  </el-card>
                </el-collapse-item>
              </el-collapse>
            </div>

            <!-- 填空 -->
            <el-card v-if="questionArray.t4[0]" v-for="(qu, idx1) in questionArray.t4" :key="idx1 + '4'">
              <div v-if="idx1 == 0"><el-divider content-position="left"> <span style="color:#CC0000">{{
    qu.i + 1
  }}.填空</span></el-divider>
              </div>

              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b> <b>{{ qu.question.title }}</b>
              <b style="color:#00CC00">[{{ qu.qscore }}分]</b> <br />
              &nbsp; &nbsp;<span v-if="parameter.type != 3">
                <input :readonly="true" type="text" v-model="qu.flag" />

                得分判定：<input :disabled="stuAnwser.isjudged > 0" @blur="checkOutScore(qu, $event)" size="4" type="text"
                  v-model="qu.rscore" />分。</span>
              <br />
              <span class="title-color-red">标准答案：<br><span style="color: #777" v-html="qu.rigthAnsr"> </span></span>
              <br>
              <span class="title-style-bold margin-top-20">题目解析:</span><br>

              <!-- 题目解析按钮 -->
              <el-button type="primary" :type="qu.stuanswer ? 'warning' : 'primary'" size="mini"
                @click="getCurrentAnalysis(qu)">更新答案-解析 {{
    qu.stuanswer ? '(' + qu.stuanswer.sn + '-' + qu.stuanswer.uptm + '有提交更新)' : '' }} </el-button>

            </el-card>

            <!-- 简答、论述、编程题 -->
            <el-card v-if="questionArray.t5[0]" v-for="(qu, idx1) in questionArray.t5" :key="idx1 + '5'">
              <div v-if="idx1 == 0"><el-divider content-position="left"> <span style="color:#CC0000">{{
    qu.i + 1
  }}.简答</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b> <b>{{ qu.question.title }}</b>
              <b style="color:#00CC00">[{{ qu.qscore }}分]</b> <br />
              <textarea :readonly="true" name="" id="" cols="150" rows="5" v-model="qu.flag"></textarea>
              &nbsp; &nbsp;<span v-if="parameter.type != 3"> <br>判定得分：<input :disabled="stuAnwser.isjudged > 0"
                  @blur="checkOutScore(qu, $event)" size="8" type="text" v-model="qu.rscore" />分。</span>
              <div style="width: 50%">

                <span class="title-color-red">标准答案：<br><span style="color: #777;font-size: 12px;"
                    v-html="qu.rigthAnsr"></span></span>
                <span class="title-color-red" v-if="qu.ays"> <br><br>判题解析：<br><span style="color: #777;font-size: 12px;"
                    v-html="qu.ays"></span></span>
                <br>
                <span class="title-style-bold margin-top-20">题目解析:
                  <!-- 题目解析按钮 -->
                  <el-button type="primary" :type="qu.stuanswer ? 'warning' : 'primary'" size="mini"
                    @click="getCurrentAnalysis(qu)">更新答案-解析 {{
    qu.stuanswer ? '(' + qu.stuanswer.sn + '-' + qu.stuanswer.uptm + '有提交更新)' : '' }}
                  </el-button></span>
              </div>
            </el-card>
            <el-card v-if="questionArray.t6[0]" v-for="(qu, idx1) in questionArray.t6" :key="idx1 + '6'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left"> <span style="color:#CC0000">{{ qu.i + 1 }}.论述</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b> <b>{{ qu.question.title }}</b>
              <b style="color:#00CC00">[{{ qu.qscore }}分]</b> <br />
              <textarea :readonly="true" name="" id="" cols="100%" rows="5" v-model="qu.flag"></textarea>
              &nbsp; &nbsp;<span v-if="parameter.type != 3"> 得分判定：
                <input :disabled="stuAnwser.isjudged > 0" @blur="checkOutScore(qu, $event)" size="4" type="text"
                  v-model="qu.rscore" /> 分。</span>

              <div style="width: 50%">

                <span style="color: #0c0">标准答案：<br><i style="color: #00f" v-html="qu.rigthAnsr"></i></span> <br>
                <span style="color: red;">题目解析:</span><br>
                <!-- 题目解析按钮 -->
                <el-button type="primary" :type="qu.stuanswer ? 'warning' : 'primary'" size="mini"
                  @click="getCurrentAnalysis(qu)">更新答案-解析 {{
    qu.stuanswer ? '(' + qu.stuanswer.sn + '-' + qu.stuanswer.uptm + '有提交更新)' : '' }} </el-button>

              </div>
            </el-card>
            <el-card v-if="questionArray.t7[0]" v-for="(qu, idx1) in questionArray.t7" :key="idx1 + '7'">
              <div v-if="idx1 == 0">
                <el-divider content-position="left"> <span style="color:#CC0000">{{ qu.i + 1 }}.编程题</span></el-divider>
              </div>
              <b>{{ qu.i + 1 }}.{{ idx1 + 1 }}</b> <b>{{ qu.question.title }}</b>
              <b style="color:#00CC00">[{{ qu.qscore }}分]</b> <br />
              <textarea :readonly="true" name="" id="" cols="100" rows="20" v-model="qu.flag"></textarea>
              &nbsp; &nbsp;<span v-if="parameter.type != 3"> 得分判定：<input :disabled="stuAnwser.isjudged > 0"
                  @blur="checkOutScore(qu, $event)" size="4" type="text" v-model="qu.rscore" />分。</span>
              <br />
              <div style="width: 50%">

                <span style="color: #0c0">标准答案：<br><i style="color: #00f" v-html="qu.rigthAnsr"> </i></span> <br>
                <span style="color: red;">题目解析:</span><br>
                <!-- 题目解析按钮 -->
                <el-button type="primary" :type="qu.stuanswer ? 'warning' : 'primary'" size="mini"
                  @click="getCurrentAnalysis(qu)">更新答案-解析 {{
    qu.stuanswer ? '(' + qu.stuanswer.sn + '-' + qu.stuanswer.uptm + '有提交更新)' : '' }} </el-button>
              </div>
            </el-card>

          </el-col>
        </el-row>
      </el-form>

      <!-- 解析弹出面板 -->
      <el-dialog title="更新答案解析" :visible.sync="dialogFormVisible" :append-to-body="true" ref="analysisForm">
        <el-form :model="currentQuestion">
          <el-form-item label="答案">
            <el-input type="textarea" v-model="currentQuestion.rigthAnsr" rows="4"></el-input>
          </el-form-item>
          <el-form-item label="学生补充答案" v-if="currentQuestion.stuanswer && currentQuestion.stuanswer.ansr">
            <el-input type="textarea" readonly :value="currentQuestion.stuanswer.ansr" rows="4"></el-input>
          </el-form-item>
          <el-form-item label="解析">
            <el-input type="textarea" v-model="currentQuestion.analysis" rows="8"></el-input>
          </el-form-item>
          <el-form-item label="学生补充解析" readonly v-if="currentQuestion.stuanswer && currentQuestion.stuanswer.anys">
            <el-input type="textarea" :value="currentQuestion.stuanswer.anys" rows="8"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('cancel')">关 闭</el-button>
          <el-button type="danger" @click="submitForm()">提交更新</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-row>
        <el-col :span="21">
          <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="close()">关 闭</el-button>
        </el-col>
        <el-col :span="3">
        </el-col>
      </el-row>
    </div>
  </popup>
</template>
<script>
import popup from "@/components/popup/drawerPopupSta.vue";
import FillInTheBlanks from "@/components/exams/FillInTheBlanks.vue";
import api from "@/api/exams/exams/exams.js";
import questionApi from "@/api/exams/question/question.js";
import ansrApi from "@/api/exams/answers/answers.js";

export default {
  components: {
    popup,
    FillInTheBlanks
  },
  data() {
    return {
      countDown: "",
      popupLoading: false,
      disabled: false,
      confirmLoading: false,

      flag1: 0,
      formParameter: {},

      parameter: {},         //exam
      kid: '',               //考试id
      studentList: [],       //已考学生列表
      studentNoKao: [],      //没考学生列表
      studentListTxt: "",    //已考学生 
      studentNeedList: "",   //应考学生列表
      student: {},           //当前批改的学生 
      stuIndex: 0,           //当前批改的学生 在数组中的位置
      exp: {},               //试卷
      expId: null,           //试卷ID
      // exmCnt: 0,              //考试的人数
      // needExmCnt: 0,          //该考试的人数
      // corectCnt: 0,           //已批改人数
      score: 0,               //客观题当前得分
      allScore: 0,             //当前得总分
      scoredetails: [],        //得分明细
      maxScore: 0,            //试卷总分
      typeTxArr: [],
      stuAnwser: { isjudged: 0 },           //学生答案
      isCanScore: 0,           // 多选题是否漏选得分：否（0） | 是 （1）
      //改分前的得分
      lastRscore: 0,

      flag1: 0,

      //题类型位置
      choice_question: { show: false },
      //题数组
      questionArray: { t1: [], t2: [], t3: [], t4: [], t5: [], t6: [], t7: [] },
      dialogFormVisible: false, // 题目解析弹出是否可见
      currentQuestion: {},    // 当前题目的解析
      searchParams: {},
      arrQid: [],//每道题的id
      arrSco: [],//每道题的得分
      row: {},
      isReJudge: false,
    };
  }, methods: {

    reJudge() {
      this.$confirm('请确认 ' + this.student.name + ' 重改？', '删除主观题判卷信息提示', {
      }).then(() => {
        this.stuAnwser.isjudged = 0
        this.isReJudge = true

        let orgScore = 0
        //扣除主观题的分
         if (this.questionArray.t5 && this.questionArray.t5.length > 0) {
          this.questionArray.t5.forEach(v => {
            if (v.rscore) {
              orgScore += v.rscore * 1
            }
          })
        }

        if (this.questionArray.t7 && this.questionArray.t7.length > 0) {
          this.questionArray.t7.forEach(v => {
            if (v.rscore) {
              orgScore += v.rscore * 1
            }
          })
        }

         //console.log("this.score",this.score)
         //console.log("orgScore",orgScore)

          this.score = this.score -orgScore


        // ansrApi.removeJudge({ kid: this.kid, stuid: this.student.id    }, res => {
        //     this.$utils.msg.success(res.msg+", 需手动关闭重新打开刷新");
        //     this.row.judgedsum = this.row.judgedsum*1 - 1

        // }, err => {
        //     this.$utils.msg.warning(err.msg);
        // })
      })
    },

    reExam() {
      this.$confirm('是否安排 ' + this.student.name + ' 重考？', '重置考试提示', {
        distinguishCancelAndClose: true, confirmButtonText: '确定重考', cancelButtonText: '取消'
      }).then(() => {
        //console.log("student.id",this.student.id)
        //console.log("kid",this.kid)
        ansrApi.removeOne({ kid: this.kid, stuid: this.student.id }, res => {
          this.$utils.msg.success(res.msg + ", 需手动关闭重新打开刷新");
          this.row.studysum = this.row.studysum * 1 - 1
        }, err => {
          this.$utils.msg.warning(err.msg);
        })

      })
    },

    showYK() {
      this.$utils.confirm.info("已完成考试 " + this.studentList.length + " 人:", this.studentListTxt)
    },

    submitPigai() {
      //询问是否完成批改？完成批改  ： 暂存成绩
      this.$confirm('是否提交 ' + this.student.name + ' 成绩【' + this.allScore + '分】？', '试卷批改提示', {
        distinguishCancelAndClose: true, confirmButtonText: '提交', cancelButtonText: '取消'
      }).then(() => {
        if (this.parameter.type == 3) { //作业
          ansrApi.update({ id: this.stuAnwser.id, score: 1, isjudged: 1 }, res => {
            this.$utils.msg.success(res.msg);
            if (!this.row.judgedsum) {
              this.row.judgedsum = 0
            }
            this.row.judgedsum = this.row.judgedsum * 1 + 1
            // console.log("this.row.judgedsum",this.row.judgedsum)
            this.stuAnwser.isjudged = 1
          }, err => {
            this.$utils.msg.warning(err.msg);
          })
        } else {
          let record
          if (this.scoredetails[this.stuIndex]) {   //本地变量有缓存
            record = this.scoredetails[this.stuIndex]
            record.isjudged = 1
          } else {
            //第一个 卷封装答案
            record = {}
            this.judged(record)
            record.isjudged = 1
            //添加进缓存
            this.scoredetails.push(record)
          }
          record.expid = this.expId
          //提交判卷
          ansrApi.update(record, res => {
            this.$utils.msg.success(res.msg);

            if (!this.row.judgedsum) {
              this.row.judgedsum = 0
            }

            if(  !this.isReJudge){
               this.row.judgedsum = this.row.judgedsum * 1 + 1
            }
  
            //  console.log("this.row.judgedsum",this.row.judgedsum)

            this.stuAnwser.isjudged = 1
          }, err => {
            this.$utils.msg.warning(err.msg);
          })
        }
      })
    }, judged(record) {
      //判卷封装答案
      record.isjudged = 0
      record.id = this.stuAnwser.id
      record.score = this.allScore
      let scoredetail = []
      //每题成绩
      this.typeTxArr.forEach((v, i) => {
        //一类题型的判卷
        let arr = []
        //一个题的判卷
        let oneAnwr = null

        this.questionArray[`t${v}`].forEach((v1, i1) => {
          oneAnwr = { rslt: v1.rslt, rscore: v1.rscore }
          arr.push(oneAnwr)
        })
        scoredetail.push(arr)
      });
      record.scoredetail = JSON.stringify(scoredetail)
    },
    moveStu(flag) {
      //判卷缓存如果有
      if (this.scoredetails[this.stuIndex]) {
        //取回回显
        let record = this.scoredetails[this.stuIndex]
        if (record.isjudged == 0) {
          //重判卷封装答案
          this.judged(record)
          //覆盖
          this.scoredetails[this.stuIndex] = record
        }
      } else {
        let record = {}
        //新判卷
        this.judged(record)
        //新加到本地变量缓存
        this.scoredetails.push(record)
      }

      //下一位
      this.stuIndex += flag
      this.student = this.studentList[this.stuIndex]
      this.score = 0;
      //重新取得学生的答案
      this.getOneAnwser(this.student.id)

    },//初始化学生答案对象
    initStudentAnswer() {

      this.flag1 = 1;

      //试卷中的试题ID---->试题
      api.getexpContent({ expid: this.expId }, (response) => {
        //试卷
        this.exp = JSON.parse(response.data);
        this.maxScore = this.exp.score;

        //题型
        let content = JSON.parse(this.exp.content)

        this.typeTxArr = content.types;
        this.typeTxArr.forEach((v, i) => {
          //初始化答案
          let qscore = content.contents[i].qscore

          this.questionArray[`t${v}`] = this.exp.contents[i].qid
          //回显答案
          this.questionArray[`t${v}`].forEach((v1, i1) => {
            v1.qscore = qscore[i1]
          })

        });

        //取得0号学生的答案
        this.getOneAnwser(this.student.id)
      });
    }, getOneAnwser(sid) {
      //  考试id       学生id
      api.getOneAnswers({ kid: this.kid, sid: sid }, res => {

        this.stuAnwser = res.data

        if (this.stuAnwser.answer) {
          let anwrArr = JSON.parse(this.stuAnwser.answer)
          //取得以前提交的成绩
          let record = {}
          let scoredetail = null
          if (this.stuAnwser.scoredetail) {   // 已完成判卷的
            //回显数据库
            scoredetail = JSON.parse(this.stuAnwser.scoredetail)
            record = { score: this.stuAnwser.score }

          } else {
            //回显本地数据
            if (this.scoredetails[this.stuIndex] && this.scoredetails[this.stuIndex].scoredetail) {
              record = this.scoredetails[this.stuIndex]
              scoredetail = JSON.parse(record.scoredetail)
            }
          }

          if (scoredetail) {

            //回显判卷
            this.typeTxArr.forEach((v, i) => {
              let anwr = anwrArr[i]

              //主观题
              this.questionArray[`t${v}`].forEach((v1, i1) => {
                //回显答案
                v1.flag = anwr[i1]
                // 判卷结果回显    scoredetail
                if (scoredetail[i]) {
                  v1.rscore = scoredetail[i][i1].rscore * 1
                  v1.rslt = scoredetail[i][i1].rslt

                  if (scoredetail[i][i1].ays) {
                    v1.ays = scoredetail[i][i1].ays;
                  }
                  this.score = record.score * 1
                } else {
                  //没有给默认0
                  v1.rscore = 0
                }
              })
            });

          } else {
            //计算判卷
            this.typeTxArr.forEach((v, i) => {
              let anwr = anwrArr[i]
              if (v > 3) {
                // 主观题人工判卷
                this.questionArray[`t${v}`].forEach((v1, i1) => {
                  v1.flag = anwr[i1]
                  // 判卷结果回显    scoredetail
                  if (scoredetail) {
                    v1.rscore = scoredetail[i][i1].rscore * 1;


                  } else {
                    v1.rscore = 0
                  }
                  this.score += v1.rscore * 1
                })
              }
            });

          }
        } else {
          //交白卷
          this.score = 0
          this.typeTxArr.forEach((v) => {
            this.questionArray[`t${v}`].forEach((v1) => {
              v1.flag = ""
              // 判卷结果
              v1.rslt = 0
              // 本题得分
              v1.rscore = 0
            })
          });
        }

        this.allScore = this.score

        //手动强制刷新
        this.$forceUpdate()
      })
    },

    //打开弹框
    open(row, title, disabled) {
      //reset
      this.stuAnwser = { isjudged: 0 }


      this.kid = row.id;
      this.row = row

      // 加载试卷+考试
      api.findPaperByKid({ kid: this.kid }, res => {

        // console.log( res.data )

        //考试
        this.parameter = res.data.exm

        //试卷ID
        this.expId = this.parameter.expid

        this.corectCnt = res.data.corectCnt
        //  this.exmCnt = res.data.exmCnt
        this.studentList = res.data.students

        this.studentListTxt = ''
        this.studentList.forEach(v => {
          this.studentListTxt += (v.name + " , ")
        })

        // 多选题漏选是否得分
        this.isCanScore = this.parameter.canScore;
        this.studentNeedList = this.parameter.sid

        let allStuNeed = JSON.parse(this.studentNeedList)

        //未考的学生
        this.studentNoKao = []

        // console.log("this.studentNeedList",this.studentNeedList)
        allStuNeed.forEach(v => {
          if (this.studentListTxt.indexOf(v) >= 0) {

          } else {
            this.studentNoKao.push(v)
          }
        })
        // this.needExmCnt = JSON.parse(this.studentNeedList).length
        this.student = this.studentList[this.stuIndex]


        if (this.flag1 == 0) {
          //初始化第一个学生答案
          this.initStudentAnswer();
        }

        this.$refs.popup.open(title, "90%");
        //2. 发起请求 根据  考试ID +学生ID 查回一个试卷+答案

        this.disabled = disabled;
      })

    }, checkOutScore(qu) {

      if (isNaN(qu.rscore)) {
        this.$utils.msg.warning("输入错误");
        qu.rscore = 0
      } else {
        if (qu.rscore < 0 || qu.rscore > qu.qscore) {
          this.$utils.msg.warning("得分越界");
          qu.rscore = 0
        }
      }

      //console.log("原始qu", qu)

      //主观题分数
      let orgScore = 0;

   
        //questionArray.t5 questionArray.t7   rscore
        if (this.questionArray.t5 && this.questionArray.t5.length > 0) {
          this.questionArray.t5.forEach(v => {
            if (v.rscore) {
              orgScore += v.rscore * 1
            }
          })
        }

        // console.log("this.score",this.score)
        // console.log("orgScore",orgScore)

        if (this.questionArray.t7 && this.questionArray.t7.length > 0) {
          this.questionArray.t7.forEach(v => {
            if (v.rscore) {
              orgScore += v.rscore * 1
            }
          })
        }

        //  console.log("score",this.score)
 
        this.allScore = this.score + orgScore * 1;
    },
    close() {
      this.disabled = false;
      this.$refs.popup.closeCallback();
      //退出初始化参数
      this.score = 0;
      this.countDown = "";
      this.popupLoading = false;
      this.disabled = false;
      this.confirmLoading = false;
      this.parameter = {};
      this.flag1 = 0;
      this.formParameter = {};
      this.choice_question = { show: false };
      this.searchParams = {};
      this.currentQuestion = {};
      this.stuIndex = 0;

      this.student = {}

      this.score = 0,               //当前得分
        this.scoredetails = [],        //得分明细
        this.maxScore = 0,            //试卷总分
        this.lastRscore = 0          //改分前的得分

      this.questionArray = {
        t1: [],
        t2: [],
        t3: [],
        t4: [],
        t5: [],
        t6: [],
        t7: [],
      };
      // this.$parent.list();

    },
    // 处理得分情况
    handlerScoringSituation(flag) {
      // 'success' : 'danger'
      var temp = {
        ctx: '',
        status: 0
      };
      // 多题是否漏选得分
      if (this.isCanScore) {
        if (flag == 1) {
          temp.ctx = '正确';
          temp.status = 'success';
        } else if (flag == 2) {
          temp.ctx = '对半';
          temp.status = 'warning';
        } else {
          temp.ctx = '错误';
          temp.status = 'danger';
        }
      } else {
        if (flag == 0 || flag == 2) {
          temp.ctx = '错误';
          temp.status = 'danger';
        } else {
          temp.ctx = '正确';
          temp.status = 'success';
        }
      }
      return temp;
    },
    // 初始化题目解析表单
    resetForm(status) {
      if (status === 'submit') { this.updateQuestion(); }
      this.dialogFormVisible = false;
    },
    // 获取当前题目的解析内容
    getCurrentAnalysis(data) {
      this.currentQuestion = data;
      this.dialogFormVisible = true;
    },
    // 更新题目信息
    updateQuestion() {
      let params = this.$utils.merger(this.searchParams, this.currentQuestion);
      questionApi.update(params, (response) => {
        this.$utils.msg.success(response.msg);
      })
    }, submitForm() {
      //提交更新
      questionApi.updateAnsr({
        id: this.currentQuestion.id,
        answer: this.currentQuestion.rigthAnsr,
        analysis: this.currentQuestion.analysis
      }, res => {
        //刷新显示
        delete this.currentQuestion.stuanswer
        this.dialogFormVisible = false;
      });

    }

  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.text {
  display: inline-block;
  padding: 0 20px;
}

.operator {
  position: absolute;
  top: 50px;
  width: 100%;
  background-color: rgba(255, 255, 255, .8);
  z-index: 999;
}

.title-style-bold {
  color: #000;
  font-weight: bold;
}

.title-color-red {
  color: red;
}

.margin-top-20 {
  margin-top: 20px;
  display: block;
}

.update-note {
  display: block;
  margin-top: 20px;
}
</style>